import axios from '~/util/axios'

export const verifyToken = async (emailToken) => {
  return await axios.post('/auth/v1/verify_email_token', { email_token: emailToken })
}

export const recoverPassword = async (options) => {
  return await axios.post('/auth/v1/sync', {
    auth_guid: options.authGuid,
    email: options.email,
    event: 'recover_password'
  })
}

export const initialize = async () => {
  return await axios.post('/auth/v1/init', {
    from_web: true
  })
}

export const requestSignIn = async (options) => {
  return await axios.post('/auth/v1/sync', {
    activation_code: options.activationCode,
    auth_guid: options.authGuid,
    event: 'request_sign_in'
  })
}

export const signIn = async (options) => {
  return await axios.post('/auth/v1/sync', {
    activation_code: options.activationCode,
    auth_guid: options.authGuid,
    authenticity_token: options.authenticityToken,
    email: options.userEmail,
    password: options.userPassword,
    event: 'sign_in'
  })
}

export const requestHelp = async (authGuid) => {
  return await axios.post('/auth/v1/sync', {
    auth_guid: authGuid,
    event: 'request_help'
  })
}

export const transitionBack = async (authGuid) => {
  return await axios.post('/auth/v1/sync', {
    auth_guid: authGuid,
    event: 'transition_back'
  })
}

export const requestNewPassword = async (authGuid) => {
  return await axios.post('/auth/v1/sync', {
    auth_guid: authGuid,
    event: 'request_new_password'
  })
}

export const start = async (authGuid) => {
  return await axios.post('/auth/v1/sync', {
    auth_guid: authGuid,
    event: 'start'
  })
}

export const startOver = async (authGuid) => {
  return await axios.post('/auth/v1/sync', {
    auth_guid: authGuid,
    event: 'start_over'
  })
}

export const connect = async (options) => {
  return await axios.post('/auth/v1/sync', {
    activation_code: options.activationCode,
    auth_guid: options.authGuid,
    email: options.userEmail,
    event: 'connect',
    locale: options.locale,
    email_from_share: options.emailFromShare
  })
}

export const sendVerification = async (options) => {
  return await axios.post('/auth/v1/sync', {
    auth_guid: options.authGuid,
    event: options.verificationMethod
  })
}

export const verifyCode = async (options) => {
  return await axios.post('/auth/v1/sync', {
    auth_guid: options.authGuid,
    verification_code: options.verificationCode,
    remember_me: options.rememberMe,
    event: 'verify'
  })
}

export const verifySsn = async (options) => {
  return await axios.post('/auth/v1/sync', {
    auth_guid: options.authGuid,
    ssn: options.ssn,
    remember_me: options.rememberMe,
    event: 'verify_ssn'
  })
}

export const requestResend = async (authGuid) => {
  return await axios.post('/auth/v1/sync', {
    auth_guid: authGuid,
    event: 'request_resend'
  })
}

export const saveInputs = async (options) => {
  return await axios.post('/auth/v1/sync', {
    auth_guid: options.authGuid,
    first_name: options.firstName,
    last_name: options.lastName,
    phone: options.phone,
    new_password: options.password,
    confirm_new_password: options.confirmPassword,
    third_party_consent: options.thirdPartyConsent,
    sms_opt_in: options.smsOptIn,
    email_token: options.emailToken,
    event: 'save_inputs'
  })
}

export const complete = async (options) => {
  const { authGuid, termsAndConditions, ...consentOptions } = options
  return await axios.post('/auth/v1/sync', {
    terms_and_conditions: termsAndConditions,
    auth_guid: authGuid,
    ...consentOptions,
    event: 'complete'
  })
}

export const completeResetPassword = async (options) => {
  return await axios.post('/auth/v1/sync', {
    auth_guid: options.authGuid,
    new_password: options.password,
    confirm_new_password: options.password,
    event: 'complete'
  })
}

export const needExpert = async (authGuid) => {
  return await axios.post('/auth/v1/sync', {
    auth_guid: authGuid,
    event: 'need_expert'
  })
}

export const saveServicer = async (options) => {
  return await axios.post('/auth/v1/sync', {
    auth_guid: options.authGuid,
    activation_code_id: options.activationCodeId,
    event: 'save_servicer'
  })
}

export const saveExpert = async (options) => {
  return await axios.post('/auth/v1/sync', {
    auth_guid: options.authGuid,
    activation_code: options.activationCode,
    activation_code_id: options.activationCodeId,
    event: 'save_expert'
  })
}

export const validatePhone = async (options) => {
  return await axios.post('/auth/v1/sync', {
    auth_guid: options.authGuid,
    phone: options.phone,
    event: 'validate_phone'
  })
}

export const validateName = async (options) => {
  return await axios.post('/auth/v1/sync', {
    auth_guid: options.authGuid,
    first_name: options.firstName,
    last_name: options.lastName,
    event: 'validate_name'
  })
}

export const skipSelection = async (authGuid) => {
  return await axios.post('/auth/v1/sync', {
    auth_guid: authGuid,
    event: 'skip_selection'
  })
}

export const confirmEmail = async (options) => {
  return await axios.post('/auth/v1/sync', {
    auth_guid: options.authGuid,
    email: options.email,
    confirm_email: options.confirm_email,
    event: 'confirm_email',
    locale: options.locale
  })
}
